module.exports = __webpack_public_path__ + "static/media/signal-4.ce65a24d.svg";